/**
 * QCard section ordering — mirror of backend `api/layout.py`.
 *
 * Keep the keys, columns, and DEFAULT_SECTION_ORDER in lockstep with the
 * backend module. PatientInfo and DischargePlan are intentionally NOT in
 * SECTION_KEYS — they are fixed headers rendered above the orderable region.
 */

export const SECTION_KEYS = [
  "milestones",
  "notes",
  "insights",
  "consideration",
  "clinical_insights",
] as const;

export type SectionKey = typeof SECTION_KEYS[number];

export const SECTION_LABELS: Record<SectionKey, string> = {
  milestones: "Milestones",
  notes: "Notes",
  insights: "24-Hour Insights",
  consideration: "Patient Consideration",
  clinical_insights: "Clinical Insights",
};

export const SECTION_COLUMNS = ["left", "right"] as const;
export type SectionColumn = typeof SECTION_COLUMNS[number];

export interface SectionOrderEntry {
  key: SectionKey;
  column: SectionColumn;
}

/**
 * Default ordering used when the API returns no value. Matches the legacy
 * "DEFAULT" QCard layout exactly: left column reads DischargePlan (fixed) →
 * Milestones → Notes → ClinicalInsights; right column reads Consideration →
 * Insights.
 */
export const DEFAULT_SECTION_ORDER: SectionOrderEntry[] = [
  { key: "milestones", column: "left" },
  { key: "notes", column: "left" },
  { key: "clinical_insights", column: "left" },
  { key: "consideration", column: "right" },
  { key: "insights", column: "right" },
];
